"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetMenuResponseToJSON = exports.GetMenuResponseFromJSONTyped = exports.GetMenuResponseFromJSON = void 0;
var _1 = require("./");
function GetMenuResponseFromJSON(json) {
    return GetMenuResponseFromJSONTyped(json, false);
}
exports.GetMenuResponseFromJSON = GetMenuResponseFromJSON;
function GetMenuResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'currency': json['currency'],
        'menus': (json['menus'].map(_1.MenuCategoryFromJSON)),
    };
}
exports.GetMenuResponseFromJSONTyped = GetMenuResponseFromJSONTyped;
function GetMenuResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'currency': value.currency,
        'menus': (value.menus.map(_1.MenuCategoryToJSON)),
    };
}
exports.GetMenuResponseToJSON = GetMenuResponseToJSON;
